define('taoQtiItem/qtiItem/core/interactions/EndAttemptInteraction',['taoQtiItem/qtiItem/core/interactions/InlineInteraction'], function(InlineInteraction){
    return InlineInteraction.extend({
        'qtiClass' : 'endAttemptInteraction'
    });
});


